// Features that have bulk import/export on the Bulk Tools page. Import needs
// "create" and export needs "read" on the matching module.
export const BULK_TOOL_MODULES = [
    "product",
    "brand",
    "category",
    "coupon",
    "banner",
    "goalCategory",
    "customGoal",
    "featureVideo",
    "faq",
    "onboardingQA",
    "spendTrackerCategory",
];
